import { useContext } from 'react';
import GlobalContext from '../context/GlobalContext';

export default () => {
  const context = useContext(GlobalContext);
  return context;
};
